import { render, staticRenderFns } from "./hero-content.vue?vue&type=template&id=3d22f54b"
import script from "./hero-content.vue?vue&type=script&lang=js"
export * from "./hero-content.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports